import Trans from '../Trans';
import { useI18n } from '../../context/I18nContext';
import './LoginFooter.css';

const LoginFooter = () => {
  const { t } = useI18n();

  return (
    <footer className="login-footer">
      <p className="login-footer-no-account">
        <Trans
          i18nKey="LoginFooter.noAccountYet"
          components={[
            null,
            <a key="contact" href={t('assets.contactUs')} target="_blank" rel="noreferrer" className="login-footer-link" />,
          ]}
        />
      </p>

      <nav className="login-footer-nav">
        <a href="https://www.netsfere.com/About-Us/About-Our-Internal-Enterprise-Messaging-Service" className="login-footer-link" target="_blank" rel="noreferrer">{t('LoginFooter.about')}</a>
        <a href="https://help.netsfere.com/" className="login-footer-link" target="_blank" rel="noreferrer">{t('LoginFooter.help')}</a>
        <a href="https://www.netsfere.com/About-Us/Secure-Enterprise-Messaging-Support-Services" className="login-footer-link" target="_blank" rel="noreferrer">{t('LoginFooter.support')}</a>
      </nav>

      <p className="login-footer-terms">
        <Trans
          i18nKey="LoginFooter.termsAndAgreements"
          components={[
            null,
            <span key="space"> </span>,
            <a key="terms" href={`/${t('assets.legal')}`} target="_blank" rel="noreferrer" className="login-footer-link" />,
          ]}
        />
      </p>
    </footer>
  );
};

export default LoginFooter;
